import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ScrollToTopButton',
    props: {
        offset: { default: 0 }
    },
    setup(__props) {
        const props = __props;
        library.add(faChevronUp);
        return { __sfc: true, props, FontAwesomeIcon, BButton };
    }
});
